import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Save, Building2 } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", company: "", address: "", siret: "", phone: "", email: "", iban: "", logo_url: "", signature_url: "" };

export default function Parametres() {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/settings").then(r => setForm({...empty, ...r.data})); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", form);
      toast.success("Paramètres enregistrés");
    } catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="parametres-page">
      <div>
        <div className="text-overline">Configuration</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{fontFamily:'Outfit'}}>Paramètres bailleur</h1>
        <p className="text-sm text-zinc-500 mt-1">Ces informations apparaissent automatiquement sur vos quittances</p>
      </div>

      <Card className="card-flat p-6 space-y-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-zinc-900"><Building2 className="w-4 h-4" />Identité</div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Nom complet</Label><Input data-testid="settings-name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} /></div>
          <div><Label>Raison sociale (si SCI/SAS)</Label><Input value={form.company} onChange={(e) => setForm({...form, company: e.target.value})} /></div>
        </div>
        <div><Label>Adresse complète</Label><Textarea rows={2} value={form.address} onChange={(e) => setForm({...form, address: e.target.value})} /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>SIRET</Label><Input value={form.siret} onChange={(e) => setForm({...form, siret: e.target.value})} /></div>
          <div><Label>Téléphone</Label><Input value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} /></div>
        </div>
        <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} /></div>
      </Card>

      <Card className="card-flat p-6 space-y-4">
        <div className="text-sm font-semibold text-zinc-900">Coordonnées bancaires & visuel</div>
        <div><Label>IBAN</Label><Input data-testid="settings-iban" value={form.iban} onChange={(e) => setForm({...form, iban: e.target.value})} placeholder="FR76 …" /></div>
        <div><Label>Logo (URL)</Label><Input value={form.logo_url} onChange={(e) => setForm({...form, logo_url: e.target.value})} placeholder="https://…" /></div>
        <div><Label>Signature (URL image)</Label><Input value={form.signature_url} onChange={(e) => setForm({...form, signature_url: e.target.value})} placeholder="https://…" /></div>
      </Card>

      <div className="flex justify-end">
        <Button onClick={save} disabled={saving} data-testid="settings-save-btn"><Save className="w-4 h-4 mr-1.5" />{saving ? "Enregistrement…" : "Enregistrer"}</Button>
      </div>
    </div>
  );
}
